// extracted by mini-css-extract-plugin
export default {"myBtn":"IconButton_myBtn__+swrZ","disabled":"IconButton_disabled__zwLmS","dark":"IconButton_dark__s5p18"};